import React, { useState } from "react";
import { Link } from "react-router-dom";
import { HERO_HOME_IMAGE, HERO_HOME_IMAGE_FALLBACK } from "../lib/data";
import { scrollToSeaMossChoice } from "../lib/plainGoldCart";
import { HOME_CTA_DARK_OUTLINE, HOME_CTA_DARK_PRIMARY } from "../lib/homeCta";

/**
 * Product-led homepage hero — coastal energy, clear type, straight to the order panel.
 */
const Hero = () => {
  const [productSrc, setProductSrc] = useState(HERO_HOME_IMAGE);
  const [bgFailed, setBgFailed] = useState(false);

  const bgSrc = bgFailed
    ? `${process.env.PUBLIC_URL || ""}/images/lifestyle/tropical-ocean-horizon.jpg`
    : `${process.env.PUBLIC_URL || ""}/images/lifestyle/caribbean-coastal-turquoise.jpg`;

  return (
    <section
      id="top"
      className="relative min-h-[62vh] md:min-h-[78vh] flex flex-col justify-center overflow-hidden mm-image-stage"
      aria-label="Moss Matrix hero"
    >
      <div className="absolute inset-0" aria-hidden>
        <img
          src={bgSrc}
          alt=""
          className="absolute inset-0 w-full h-full object-cover object-[center_35%] scale-[1.04] brightness-[1.14] contrast-[1.04] saturate-[1.05]"
          onError={() => setBgFailed(true)}
        />
        <div
          className="absolute inset-0 pointer-events-none"
          style={{
            background:
              "linear-gradient(105deg, rgba(5,7,6,0.78) 0%, rgba(5,7,6,0.52) 34%, rgba(5,7,6,0.22) 58%, rgba(5,7,6,0.4) 100%), linear-gradient(180deg, rgba(5,7,6,0.28) 0%, transparent 38%, rgba(5,7,6,0.55) 100%)",
          }}
        />
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 md:px-10 pt-14 pb-10 md:pt-20 md:pb-14">
        <div className="grid lg:grid-cols-[minmax(0,1.05fr)_minmax(0,0.95fr)] gap-7 lg:gap-10 items-center">
          <div className="max-w-xl lg:max-w-2xl">
            <p className="home-eyebrow m-0">Moss Matrix</p>
            <h1
              className="mt-4 md:mt-5 font-display font-semibold text-[2.5rem] sm:text-5xl md:text-6xl lg:text-[3.9rem] leading-[0.95] tracking-tight text-ivory"
              style={{ textShadow: "0 2px 28px rgba(0,0,0,0.55)" }}
            >
              Fresh Sea Moss for Active Routines
            </h1>
            <p
              className="mt-5 md:mt-6 text-base md:text-lg text-ivory/90 leading-relaxed max-w-xl font-sans"
              style={{ textShadow: "0 1px 14px rgba(0,0,0,0.4)" }}
            >
              Gold or Purple Sea Moss Gel, freshly prepared and fridge-ready. Choose jar or pouch, pick your size, and
              keep your routine simple.
            </p>

            <div className="mt-7 md:mt-8 flex flex-col sm:flex-row flex-wrap items-stretch sm:items-center gap-3">
              <button
                type="button"
                onClick={() => scrollToSeaMossChoice()}
                data-testid="hero-choose-sea-moss"
                className={`${HOME_CTA_DARK_PRIMARY} w-full sm:w-auto min-h-[52px] px-8 py-3.5`}
              >
                Choose Your Sea Moss
              </button>
              <Link
                to="/reviews"
                data-testid="hero-read-feedback"
                className={`${HOME_CTA_DARK_OUTLINE} w-full sm:w-auto min-h-[52px] px-8 py-3.5 inline-flex items-center justify-center`}
              >
                Read Customer Feedback
              </Link>
            </div>
          </div>

          <div className="relative w-full min-w-0 max-w-xl mx-auto lg:max-w-none">
            <div
              className="absolute -inset-8 md:-inset-12 rounded-full pointer-events-none blur-3xl opacity-80"
              style={{
                background:
                  "radial-gradient(circle at 40% 38%, rgba(215,179,84,0.42), transparent 52%), radial-gradient(circle at 72% 62%, rgba(122,63,160,0.22), transparent 48%)",
              }}
              aria-hidden
            />
            <div className="relative rounded-[1.75rem] md:rounded-[2.25rem] overflow-hidden aspect-[5/4] sm:aspect-[4/3] max-h-[280px] sm:max-h-[420px] md:max-h-[460px] mx-auto w-full ring-1 ring-[rgba(248,241,223,0.22)] shadow-[0_40px_80px_-28px_rgba(0,0,0,0.55)] bg-[#0c1210]">
              <img
                src={productSrc}
                alt="Moss Matrix Gold and Purple Sea Moss Gel jar and pouch"
                className="w-full h-full object-cover object-center mm-hero-product-img"
                onError={() => {
                  if (productSrc !== HERO_HOME_IMAGE_FALLBACK) setProductSrc(HERO_HOME_IMAGE_FALLBACK);
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
